import React, { Component } from "react";
import { connect } from 'react-redux'
import { signInUser } from '../redux-token-auth-config';
import { Button, FormGroup, FormControl} from "react-bootstrap";
import '../../stylesheets/LoginPage.scss';

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: ""
    };

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault()
    const {email, password} = this.state;
    const { signInUser } = this.props;

    signInUser({ email, password }).then(() => {
    }).catch(() => {
      console.log('FAILED TO LOGGIN')
    })
  }

  render() {

    return (
      <div className={`login col-md-offset-4 col-md-4`}>
        <h4>Please login</h4>
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="email">
            <FormControl
              autoFocus
              type="email"
              value={this.state.email}
              onChange={this.handleChange}
              placeholder='Email'
            />
          </FormGroup>
          <FormGroup controlId="password">
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
              placeholder='Password'
            />
          </FormGroup>
          <Button
            block
            disabled={!this.validateForm()}
            type="submit"
          >
            Login
          </Button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {currentUser: state.reduxTokenAuth.currentUser}
}

export default connect(
  mapStateToProps,
  { signInUser },
)(LoginPage)



// WEBPACK FOOTER //
// ./src/authentication/javascripts/components/LoginPage.jsx